// This file is automatically generated with create-ts-svgs script in package.json
import * as React from 'react'; 
			
interface ISvgProps {
	className?: string,
}
			
const fn: React.FunctionComponent<ISvgProps> = (props) => (
	<svg className={props.className} viewBox="0 0 5.936 13.999"><path d="M1 14a1 1 0 01-.837-1.547L3.74 6.97.165 1.55a1 1 0 011.67-1.1L5.77 6.415a1 1 0 01.003 1.097l-3.935 6.033a.998.998 0 01-.838.453z"/></svg>
);

export default fn;
